module.exports = __webpack_public_path__ + "img/passport-wrong-blackwhite.6214cc0c.png";